import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../style.module.scss"
import { LazyLoadImage } from 'react-lazy-load-image-component'
import Deeplink from "../../../../utils/deeplink";
import withSource from '../../../hocs/source-scoll'
import { getSensorsUrl } from "../../../utils/sensor";

const Item = withSource(props =>{
    useStyles(classes)
    const { banner, innerRef } = props;
    const { imageUrl, imageRatio, deeplink, refId } = banner;

    let aspectRatio = imageRatio ? `${Math.floor(imageRatio*100)}%` : `${Math.floor(404*100/750)}%`

    const handleClick = event => {
		event.preventDefault()
        const { currentTarget } = event;

		const href = currentTarget?.href
		window.location.href = getSensorsUrl(href, {
			resourcepage_title: currentTarget.getAttribute("data-title"),
			resource_type: currentTarget.getAttribute("data-type"),
            resource_position: currentTarget.getAttribute("data-position"),
			resource_content: currentTarget.getAttribute("data-content"),
		})
	}

    return <div>
        <div className={`${classes.GolbalBorderTop} ${classes.ProductDiscountContainer}`}>
            <a 
                ref={innerRef}
                onClick={handleClick}
                data-title="product"
                data-position={1}
                data-type={1}
                data-content={refId}
                href={Deeplink(deeplink, "msite")} 
                style={{paddingTop: aspectRatio, backgroundColor:'#f7f7f7'}}
            >
                <LazyLoadImage src={imageUrl} alt="productDisount" />
            </a>
        </div>
    </div>
})

const ProductDiscountMessage = props =>{
   const { banner } = props

    return banner ? <Item {...props} />: <React.Fragment/>
}

export default ProductDiscountMessage;